module.exports = __webpack_public_path__ + "static/FESP_Faculdades-4c4f5213224258443cb7739481e495dd.png";